import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export const StickyController = class extends Controller {
  connect() {
    this.$buttonAre = $(this.element);
    this.buttonAreHeight = this.$buttonAre.outerHeight();
    this.buttonAreTop = $(".js-sticky-button-area-top").offset().top;

    this._scrollHandler = this.handleScroll.bind(this);
    $(window).on("scroll", this._scrollHandler);
  }

  disconnect() {
    $(window).off("scroll", this._scrollHandler);
  }

  handleScroll() {
    var scrollTop = $(window).scrollTop();
    var windowHeight = $(window).height();

    if (scrollTop + windowHeight < this.buttonAreTop + this.buttonAreHeight) {
      this.$buttonAre.addClass("is-sticky");
    } else {
      this.$buttonAre.removeClass("is-sticky");
    }
  }
};
